(() => {
  if (document.body && document.body.classList.contains('template-product')) return;
  const DEFAULT_MINIMUM_CENTS = 1500;
  const config = window.ResinMinimumOrder || {};
  let minimumCents = Number(config.minimumCents) || DEFAULT_MINIMUM_CENTS;
  let currency = config.currency || 'USD';
  let subtotalCents = null;
  let fetching = false;
  let refreshTimer = null;

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  };

  const readMinimumFromPage = () => {
    const marker = document.querySelector('[data-resin-minimum-order]');
    if (!marker) return;
    const pageMinimum = Number(marker.dataset.minimumOrderCents);
    if (pageMinimum > 0) minimumCents = pageMinimum;
  };

  const setHidden = (element, hidden) => {
    element.hidden = hidden;
    element.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    element.dataset.resinMinimumHidden = hidden ? 'true' : 'false';
  };

  const updateMessages = (underMinimum, neededCents) => {
    document.querySelectorAll('[data-resin-minimum-order]').forEach((message) => {
      setHidden(message, !underMinimum);
      message.dataset.cartSubtotalCents = String(subtotalCents || 0);
      const label = message.dataset.minimumOrderLabel || money(minimumCents);
      const delta = message.querySelector('[data-resin-minimum-order-delta]');
      if (delta) {
        delta.textContent = `Add ${money(neededCents)} more to reach the ${label} minimum.`;
      }
    });
  };

  const updateCheckoutButtons = (underMinimum) => {
    document.querySelectorAll('[data-resin-checkout-button], button[name="checkout"]').forEach((button) => {
      button.disabled = underMinimum;
      button.setAttribute('aria-disabled', underMinimum ? 'true' : 'false');
      button.dataset.resinMinimumDisabled = underMinimum ? 'true' : 'false';
    });
  };

  const updateAcceleratedCheckout = (underMinimum) => {
    document.querySelectorAll('[data-resin-accelerated-checkout], .additional-checkout-buttons, .shopify-payment-button').forEach((element) => {
      setHidden(element, underMinimum);
    });
  };

  const focusMinimumMessage = () => {
    const message = document.querySelector('[data-resin-minimum-order]:not([hidden])');
    if (!message) return;
    if (!message.hasAttribute('tabindex')) message.setAttribute('tabindex', '-1');
    message.focus({ preventScroll: true });
    message.scrollIntoView({ block: 'center', behavior: 'smooth' });
  };

  const applyState = (cart) => {
    readMinimumFromPage();

    if (cart) {
      subtotalCents = Number(cart.items_subtotal_price ?? cart.total_price ?? 0);
      if (cart.currency) currency = cart.currency;
    }

    if (subtotalCents === null) {
      const marker = document.querySelector('[data-resin-minimum-order]');
      subtotalCents = Number(marker?.dataset.cartSubtotalCents || 0);
    }

    const neededCents = Math.max(minimumCents - subtotalCents, 0);
    const underMinimum = subtotalCents < minimumCents;

    updateMessages(underMinimum, neededCents);
    updateCheckoutButtons(underMinimum);
    updateAcceleratedCheckout(underMinimum);

    document.documentElement.dataset.resinMinimumOrderMet = underMinimum ? 'false' : 'true';
  };

  const refreshCart = () => {
    if (fetching) return;
    fetching = true;

    fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (cart) applyState(cart);
      })
      .catch(() => applyState())
      .finally(() => {
        fetching = false;
      });
  };

  const scheduleRefresh = () => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshCart, 120);
  };

  const blocksCheckout = () => subtotalCents !== null && subtotalCents < minimumCents;

  document.addEventListener('click', (event) => {
    const checkoutTarget = event.target.closest('button[name="checkout"], [data-resin-checkout-button], a[href*="/checkout"], .shopify-payment-button button');
    if (!checkoutTarget || !blocksCheckout()) return;
    event.preventDefault();
    event.stopPropagation();
    focusMinimumMessage();
  }, true);

  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    const isCheckoutSubmit = submitter?.name === 'checkout' || event.target.querySelector('[name="checkout"]');
    if (!isCheckoutSubmit || !blocksCheckout()) return;
    event.preventDefault();
    event.stopPropagation();
    focusMinimumMessage();
  }, true);

  document.addEventListener('cart:updated', (event) => applyState(event.detail?.cart));
  document.addEventListener('ajaxProduct:added', scheduleRefresh);
  document.addEventListener('cart:refresh', scheduleRefresh);
  document.addEventListener('change', (event) => {
    if (event.target.closest('cart-items, cart-drawer, form[action*="/cart"]')) scheduleRefresh();
  });

  const observer = new MutationObserver(() => {
    if (document.querySelector('[data-resin-minimum-order], [data-resin-accelerated-checkout], button[name="checkout"]')) {
      applyState();
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    readMinimumFromPage();
    refreshCart();
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
